import { useCallback } from 'react';
import { useResizeDetector } from 'react-resize-detector';
import { setWindowSize } from '../../redux/slices/userSettings';
import { useAppDispatch } from '../../redux/hooks';

const useResizeLayout = () => {
  const dispatch = useAppDispatch();

  const handleResizeWindow = useCallback(
    (width?: number, height?: number) => {
      if (typeof width === 'number' && typeof height === 'number') {
        dispatch(
          setWindowSize({
            width,
            height,
          }),
        );
      }
    },
    [dispatch],
  );

  const { ref } = useResizeDetector({
    refreshMode: 'debounce',
    refreshRate: 600,
    onResize: handleResizeWindow,
  });

  return ref;
};

export default useResizeLayout;
